import dayjs from "dayjs";
import formatarDuracao from "../../utils/formatarDuracao";

export const STATUS_QUEUED = "na_fila";
export const STATUS_PAUSED = "pausado";
export const STATUS_ABSENT = "ausente_dia";

export const PAUSE_OPTIONS = [
  { value: "almoco", label: "Almoço" },
  { value: "banheiro", label: "Banheiro" },
  { value: "outro", label: "Outro" },
];

const PAUSE_LABELS = {
  almoco: "almoço",
  banheiro: "banheiro",
  outro: "pausa",
};

export function formatElapsed(since, now = new Date()) {
  if (!since) return "";
  const minutes = dayjs(now).diff(dayjs(since), "minute");
  if (minutes < 1) return "agora";
  return formatarDuracao(minutes);
}

export function statusLabel(entry, now = new Date()) {
  if (!entry) return "";
  if (entry.status === STATUS_ABSENT) return "ausente hoje";
  if (entry.status === STATUS_PAUSED) {
    const reason = PAUSE_LABELS[entry.pause_reason] || "pausa";
    const elapsed = formatElapsed(entry.status_changed_at, now);
    return elapsed ? `${reason} ${elapsed}` : reason;
  }
  return "na fila";
}
